export default __webpack_public_path__ + "static/media/Water_sensor.54740682.svg";